import { TYPES } from '../actions';

const initialState = {
  products: [],
  currentProduct: null,
  totalCount: 0,
  loading: false,
  error: null
};

export const sesProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_SES_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload.data.result,
        totalCount: action.payload.data.totalCount || 0,
        loading: false,
        error: null
      };

    case TYPES.ACTION_SET_SES_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload.data.result,
        totalCount: action.payload.data.totalCount || 0,
        loading: false,
        error: null
      };

    case TYPES.ACTION_ADD_SES_PRODUCTS_SUCCESS:
      var oldProductIds = state.products.map(product => product._id);
      var newProductIds = action.payload.data.map(product => product._id);
      var newProducts = action.payload.data.filter(product => !oldProductIds.includes(product._id));
      
      return {
        ...state,
        products: [...state.products, ...action.payload.data],
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SES_PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        currentProduct: action.payload.data,
        loading: false,
        error: null
      };

    case TYPES.ACTION_CREATE_SES_PRODUCT_SUCCESS:
      return {
        ...state,
        products: [...state.products, action.payload.data],
        loading: false,
        error: null
      };

    case TYPES.ACTION_UPDATE_SES_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.map(product => 
          product._id === action.payload.data._id ? action.payload.data : product
        ),
        currentProduct: action.payload.data,
        loading: false,
        error: null
      };

    case TYPES.ACTION_DELETE_SES_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.filter(product => product._id !== action.payload.data[0]._id),
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SES_PRODUCTS_FAIL:
    case TYPES.ACTION_SET_SES_PRODUCTS_FAIL:
    case TYPES.ACTION_ADD_SES_PRODUCTS_FAIL:
    case TYPES.ACTION_GET_SES_PRODUCT_BY_ID_FAIL:
    case TYPES.ACTION_CREATE_SES_PRODUCT_FAIL:
    case TYPES.ACTION_UPDATE_SES_PRODUCT_FAIL:
    case TYPES.ACTION_DELETE_SES_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}; 